import { render, staticRenderFns } from "./Product360Viewer.vue?vue&type=template&id=7322f1ca&scoped=true"
import script from "./Product360Viewer.vue?vue&type=script&lang=js"
export * from "./Product360Viewer.vue?vue&type=script&lang=js"
import style0 from "./Product360Viewer.vue?vue&type=style&index=0&id=7322f1ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7322f1ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7322f1ca')) {
      api.createRecord('7322f1ca', component.options)
    } else {
      api.reload('7322f1ca', component.options)
    }
    module.hot.accept("./Product360Viewer.vue?vue&type=template&id=7322f1ca&scoped=true", function () {
      api.rerender('7322f1ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/product/Product360Viewer.vue"
export default component.exports